import { ActionType } from './actions'

export type Store = {
  message: string
  severity: 'error' | 'warning' | 'info' | 'success'
  statusCode: number
  isShown: boolean
  duration?: number
}

const initialState: Store = {
  isShown: false,
  severity: 'error',
  message: 'Something',
  statusCode: 200
}

function setByErrorStatus(status: number, message?: string): Store {
  console.log(status, message)
  if (status >= 200 && status < 300) {
    return {
      isShown: false,
      message: 'Sorry we could not find it',
      statusCode: 200,
      severity: 'warning',
      duration: 4000
    }
  } else if (status === 404) {
    return {
      isShown: false,
      message: 'Sorry we could not find it',
      statusCode: 404,
      severity: 'warning',
      duration: 4000
    }
  } else if (status >= 500) {
    return {
      isShown: true,
      statusCode: status,
      severity: 'warning',
      duration: 6000,
      message: message || 'It seems to be problems with the server'
    }
  } else if (Number.isInteger(status) && status > 0) {
    return {
      isShown: true,
      statusCode: status,
      severity: 'error',
      duration: 6000,
      message: message || 'It seems to be problems with the connection'
    }
  } else {
    return {
      isShown: false,
      message: 'Undefined Error',
      statusCode: 0,
      severity: 'error',
      duration: 6000
    }
  }
}

export type ErrorActionDispatcherParams =
  | {
      type: ActionType.SET_ERROR
      payload: Partial<Store>
    }
  | {
      type: ActionType.SET_BY_STATUS
      payload: Pick<Store, 'message'> & { statusCode: number }
    }
  | {
      type: ActionType.CLEAN_ERROR
    }

export default function (
  state: Store = initialState,
  action: ErrorActionDispatcherParams
): Store {
  switch (action.type) {
    case ActionType.SET_ERROR:
      return { ...state, ...action.payload }
    case ActionType.SET_BY_STATUS:
      return setByErrorStatus(
        action.payload.statusCode || 0,
        action.payload.message
      )
    case ActionType.CLEAN_ERROR:
      return {
        isShown: false,
        message: 'ok',
        severity: 'success',
        statusCode: 200
      }
    default:
      return { ...state }
  }
}
